module.exports = {
      id: "close-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#close",
      toString: function () {
        return this.url;
      }
    }